'use client'

import { Button } from '@/components/ui/Button'

interface ScrollCtaProps {
  /** id of the section to scroll to (no leading #) */
  targetId: string
  size?: 'md' | 'lg'
  className?: string
  children: React.ReactNode
}

/**
 * Scroll CTA that works on every click. A plain href="#id" link goes dead
 * after the first use — once the hash is set, re-clicks fire no hashchange
 * and the page never moves.
 */
export function ScrollCta({
  targetId,
  size = 'lg',
  className,
  children,
}: ScrollCtaProps) {
  return (
    <Button
      size={size}
      className={className}
      onClick={() => {
        const target = document.getElementById(targetId)
        if (!target) return
        const reduced = window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches
        target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' })
      }}
    >
      {children}
    </Button>
  )
}
